import type { QuickscanResult } from '@wtta/scoring'

interface ScoreSectionProps {
  result: QuickscanResult
}

export function ScoreSection({ result }: ScoreSectionProps) {
  return (
    <section className="report-section" data-testid="score-section">
      <h2 className="report-section__title">Readiness per onderwerp</h2>
      <p className="report-section__lead">
        Hieronder zie je jouw score per onderwerp. Categorieën gemarkeerd als{' '}
        <strong className="risk-high">hoog risico</strong> hebben prioriteit.
      </p>
      <ul className="category-list">
        {result.categoryScores.map((category) => (
          <li
            key={category.categoryId}
            className={`category-list__item category-list__item--${category.riskLevel}`}
            data-testid={`category-${category.categoryId}`}
          >
            <div className="category-list__heading">
              <span className="category-list__title">{category.categoryTitle}</span>
              <span className="category-list__score">{category.percentage}%</span>
            </div>
            <div className="category-list__bar">
              <span
                className="category-list__bar-fill"
                style={{ width: `${category.percentage}%` }}
              />
            </div>
          </li>
        ))}
      </ul>

      {result.strengths.length > 0 ? (
        <div className="highlight-block highlight-block--strengths">
          <h3>Sterke punten</h3>
          <ul>
            {result.strengths.map((strength) => (
              <li key={strength}>{strength}</li>
            ))}
          </ul>
        </div>
      ) : null}

      {result.concerns.length > 0 ? (
        <div className="highlight-block highlight-block--concerns">
          <h3>Aandachtspunten</h3>
          <ul>
            {result.concerns.map((concern) => (
              <li key={concern}>{concern}</li>
            ))}
          </ul>
        </div>
      ) : null}
    </section>
  )
}
